import { useCallback } from "react";

import { useProductRoomFormModelContext } from "../../../../context";

/**
 * `isShowStockPreview` は GraphQL 上 `Boolean`（nullable）。
 * default-input-model で必ず `false` に初期化されるため運用上は undefined にならないが、
 * 型上は optional なので呼び出し側でフィールド存在チェックを行う。
 */
export const useRoomIsShowStockPreview = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { isShowStockPreview } = viewModel;

	const onSetIsShowStockPreview = useCallback(
		(input: boolean) => {
			if (!isShowStockPreview) return;
			onSetViewModel([
				{
					key: "isShowStockPreview",
					value: { ...isShowStockPreview, value: input },
				},
			]);
		},
		[isShowStockPreview, onSetViewModel],
	);

	return {
		isShowStockPreview,
		onSetIsShowStockPreview,
	};
};
